import { Component } from '@angular/core';

@Component({
  selector: 'icon-eye',
  templateUrl: './icon-eye.component.html',
  styles: []
})
export class IconEyeComponent {}
